import axios from "axios";
import store from "@/store";
import { logError } from "@/services/logging/loggingService";
import { configAutoLogout } from "@/services/security/authService";
import router from "@/router";
export function setUpResponseInterceptors() {
    axios.interceptors.response.use(
        function success(response: any) {
            jwtHandler(response.headers.jwttoken);
            return response;
        },
        function error(error: any) {
            unAuthorizedHandler(error);
            logError(`Request failed: ${error.config.method.toUpperCase()} ${error.config.url} - ${error.response.status} ${error.response.statusText}`);
            return Promise.reject(error);
        }
    );
}
// interceptor handlers
function jwtHandler(token: any) {
    if (!token) return;
    store.commit("authentication/updateToken", token);
    configAutoLogout();
}
function unAuthorizedHandler(error: any) {
    if (!error.request ||
        error.response.status !== 401) return;
    if (!error.config ||
        error.config.__isRetryRequest) return;
    store.commit("authentication/authClear");
    router.push("/login");
}
